import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col,
  Media,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import SocketComponent from "../../SocketComponent/SocketComponent";
//i18b
import { withTranslation } from "react-i18next";
import notificationSound from "./Chat-Alert.wav";
import { toast } from "react-toastify"; // Import toast
import { getAdminNotificationList } from "../../../Endpoint/Admin";
// ACM - Permission Service
import { hasModuleAccess } from "../../../services/PermissionService";
//Import images
import avatar3 from "../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../assets/images/users/avatar-4.jpg";
import { Field } from "redux-form";

class NotificationDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      notifications: [],
    };

    this.toggle = this.toggle.bind(this);
    this.audio = new Audio(notificationSound);
  }

  componentDidMount() {
    // Call the API when the component mounts
    this.fetchNotifications();
  }

  fetchNotifications() {
    // Call your API to fetch notifications
    getAdminNotificationList()
      .then((response) => {
        // Assuming the API response is an array of notifications
        this.setState({ notifications: response.data });
        console.log(response);
      })
      .catch((error) => {
        console.error("Error fetching notifications:", error);
      });
  }

  // Notification Types:
  //   1 - Food Order
  //   2 - Room Booking
  //   3 - Table Booking
  //   4 - Custom
  //   5 - Transport/Taxi
  //   6 - Chat

  // Map notification type to module ID for permission checking
  getNotificationModuleId = (notificationType) => {
    switch (notificationType) {
      case 1:
        return "FOOD";
      case 2:
        return "ROOM";
      case 3:
        return "FOOD"; // Table booking is under FOOD module
      case 4:
        return null; // Custom notifications - no specific module
      case 5:
        return "TRANSPORTATION";
      case 6:
        return "CHAT";
      default:
        return null;
    }
  };

  // Check if user has permission for this notification type
  hasNotificationAccess = (notificationType) => {
    const moduleId = this.getNotificationModuleId(notificationType);
    // Custom notifications (type 4) or unknown types are always accessible
    if (!moduleId) return true;
    return hasModuleAccess(moduleId);
  };

  getNotificationPath = (notificationType, entityId) => {
    // Check permission first
    if (!this.hasNotificationAccess(notificationType)) {
      return null; // No access - will be handled in render
    }

    switch (notificationType) {
      case 1:
        return "/FoodOrder";
      case 2:
        return "/Booking";
      case 3:
        return "/TableBooking";
      case 4:
        return "/";
      case 5:
        return "/transport/requests";
      case 6:
        // Include chatId for deep linking to specific chat
        // Convert to string in case it's an ObjectId object
        return entityId ? `/ChatList?chatId=${String(entityId)}` : "/ChatList";
      default:
        return "/";
    }
  };

  getNotificationInfoIcon = (notificationType) => {
    switch (notificationType) {
      case 1:
        return "ri-restaurant-line";
      case 2:
        return "ri-hotel-bed-fill";
      case 3:
        return "ri-table-fill";
      case 4:
        return "ri-notification-3-line";
      case 5:
        return "ri-taxi-line";
      case 6:
        return "ri-message-2-fill";
      default:
        return "ri-notification-3-line";
    }
  };

  handleNewNotification = (data) => {
    // Refresh notifications list
    this.fetchNotifications();

    // If data is just a count update (e.g., {notificationCount: 1}), don't show a toast
    if (typeof data === "object" && data.notificationCount !== undefined && !data.title && !data.message && !data.details) {
      console.log("Notification count update:", data.notificationCount);
      return;
    }

    // Parse notification data first to check permissions
    let title = "New Notification";
    let message = data;
    let icon = "ri-notification-3-line";
    let toastType = "info";
    let navigateTo = "/";
    let notificationType = 4; // Default to custom
    let moduleId = null;

    // Handle different notification types based on content
    if (typeof data === "string") {
      const lowerData = data.toLowerCase();
      if (lowerData.includes("food") || (lowerData.includes("order") && !lowerData.includes("room") && !lowerData.includes("table"))) {
        title = "🍽️ New Food Order";
        icon = "ri-restaurant-line";
        toastType = "success";
        navigateTo = "/FoodOrder";
        notificationType = 1;
        moduleId = "FOOD";
      } else if (lowerData.includes("room")) {
        title = "🏨 New Room Booking";
        icon = "ri-hotel-bed-line";
        toastType = "info";
        navigateTo = "/Booking";
        notificationType = 2;
        moduleId = "ROOM";
      } else if (lowerData.includes("table")) {
        title = "🪑 New Table Booking";
        icon = "ri-table-line";
        toastType = "info";
        navigateTo = "/TableBooking";
        notificationType = 3;
        moduleId = "FOOD";
      } else if (lowerData.includes("transport") || lowerData.includes("taxi")) {
        title = "🚗 New Transport Request";
        icon = "ri-taxi-line";
        toastType = "warning";
        navigateTo = "/transport/requests";
        notificationType = 5;
        moduleId = "TRANSPORTATION";
      } else if (lowerData.includes("chat") || lowerData.includes("message")) {
        title = "💬 New Message";
        icon = "ri-message-2-line";
        toastType = "info";
        navigateTo = "/ChatList"; // Will be updated with chatId if available in data object
        notificationType = 6;
        moduleId = "CHAT";
      }
      message = data;
    } else if (typeof data === "object") {
      title = data.title || title;
      message = data.details || data.message || JSON.stringify(data);
      // Get navigation path from notification type if available
      if (data.type) {
        notificationType = data.type;
        moduleId = this.getNotificationModuleId(data.type);
        // Pass entityId for deep linking (e.g., chatId for chat notifications)
        navigateTo = this.getNotificationPath(data.type, data.entityId) || "/";
      }
    }

    // ACM: Check if user has permission for this notification type
    const hasAccess = !moduleId || hasModuleAccess(moduleId);

    // Don't show notification if user doesn't have access to the module
    if (!hasAccess) {
      console.log("Notification filtered - no access to module:", moduleId);
      return;
    }

    // Play notification sound
    this.audio.play();
    console.log("New notification received:", data);

    // Navigate function for toast click
    const handleToastClick = () => {
      if (hasAccess && navigateTo) {
        window.location.href = navigateTo;
      }
    };

    // Show toast notification with custom content
    const ToastContent = () => (
      <div
        style={{ display: "flex", alignItems: "flex-start", cursor: hasAccess ? "pointer" : "default" }}
        onClick={handleToastClick}
      >
        <i className={icon} style={{ fontSize: "24px", marginRight: "12px", marginTop: "2px" }}></i>
        <div>
          <strong style={{ display: "block", marginBottom: "4px" }}>{title}</strong>
          <span style={{ fontSize: "13px", opacity: 0.9 }}>{message}</span>
          {hasAccess && (
            <small style={{ display: "block", marginTop: "6px", opacity: 0.7 }}>
              Click to view →
            </small>
          )}
        </div>
      </div>
    );

    toast[toastType](<ToastContent />, {
      position: "bottom-left",
      autoClose: 10000, // Auto close after 10 seconds
      hideProgressBar: false,
      closeOnClick: false, // Don't close on click, let our handler work
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      style: { minWidth: "350px", cursor: hasAccess ? "pointer" : "default" },
    });
  };

  toggle() {
    const { menu } = this.state;

    // If the dropdown is being opened
    if (!menu) {
      this.fetchNotifications();
    }

    this.setState((prevState) => ({
      menu: !prevState.menu,
    }));
  }
  render() {
    const { notifications } = this.state;

    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="d-inline-block"
        >
          <DropdownToggle
            tag="button"
            className="btn header-item noti-icon waves-effect"
            id="page-header-notifications-dropdown"
          >
            <i className="ri-notification-3-line"></i>
            <span className="noti-dot"></span>
          </DropdownToggle>
          <DropdownMenu
            right
            className="dropdown-menu-lg p-0"
            aria-labelledby="page-header-notifications-dropdown"
          >
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0"> {this.props.t("Notifications")} </h6>
                </Col>
                {/* <div className="col-auto">
                  <Link to="#" className="small">
                    {" "}
                    {this.props.t("View All")}
                  </Link>
                </div> */}
              </Row>
            </div>
            {/* <SimpleBar style={{ maxHeight: "230px" }}>
              <Link to="#" className="text-reset notification-item">
                <Media>
                  <div className="avatar-xs mr-3">
                    <span className="avatar-title bg-primary rounded-circle font-size-16">
                      <i className="ri-shopping-cart-line"></i>
                    </span>
                  </div>
                  <Media body>
                    <h6 className="mt-0 mb-1">
                      {this.props.t("Your order is placed")}
                    </h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">
                        {this.props.t(
                          "If several languages coalesce the grammar"
                        )}
                      </p>
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline"></i>{" "}
                        {this.props.t("3 min ago")}
                      </p>
                    </div>
                  </Media>
                </Media>
              </Link>
              <Link to="#" className="text-reset notification-item">
                <Media>
                  <img
                    src={avatar3}
                    className="mr-3 rounded-circle avatar-xs"
                    alt="user-pic"
                  />
                  <Media body>
                    <h6 className="mt-0 mb-1">
                      {this.props.t("James Lemire")}
                    </h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">
                        {this.props.t("It will seem like simplified English.")}
                      </p>
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline"></i>{" "}
                        {this.props.t("1 hours ago")}
                      </p>
                    </div>
                  </Media>
                </Media>
              </Link>
              <Link to="#" className="text-reset notification-item">
                <Media>
                  <div className="avatar-xs mr-3">
                    <span className="avatar-title bg-success rounded-circle font-size-16">
                      <i className="ri-checkbox-circle-line"></i>
                    </span>
                  </div>
                  <Media body>
                    <h6 className="mt-0 mb-1">
                      {this.props.t("Your item is shipped")}
                    </h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">
                        {this.props.t(
                          "If several languages coalesce the grammar"
                        )}
                      </p>
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline"></i>{" "}
                        {this.props.t("3 min ago")}
                      </p>
                    </div>
                  </Media>
                </Media>
              </Link>

              <Link to="#" className="text-reset notification-item">
                <Media>
                  <img
                    src={avatar4}
                    className="mr-3 rounded-circle avatar-xs"
                    alt="user-pic"
                  />
                  <Media body>
                    <h6 className="mt-0 mb-1">
                      {this.props.t("Salena Layfield")}
                    </h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">
                        {this.props.t(
                          "As a skeptical Cambridge friend of mine occidental."
                        )}
                      </p>
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline"></i>{" "}
                        {this.props.t("1 hours ago")}
                      </p>
                    </div>
                  </Media>
                </Media>
              </Link>
            </SimpleBar> */}
            <SimpleBar style={{ maxHeight: "230px" }}>
              {/* Map over notifications and create dynamic notification items */}
              {/* ACM: Filter notifications based on user's module permissions */}
              {Array.isArray(this.state.notifications) &&
                this.state.notifications
                  .filter((notification) => this.hasNotificationAccess(notification.type))
                  .map((notification) => {
                    const notificationPath = this.getNotificationPath(notification.type, notification.entityId);
                    return (
                      <Link
                        to={notificationPath || "/"}
                        className="text-reset notification-item"
                        key={notification._id}
                      >
                        <Media>
                          <div className="avatar-xs mr-3">
                            <span className="avatar-title bg-primary rounded-circle font-size-16">
                              <i
                                className={this.getNotificationInfoIcon(
                                  notification.type
                                )}
                              ></i>
                            </span>
                          </div>
                          <Media body>
                            <h6 className="mt-0 mb-1">{notification.title}</h6>
                            <div className="font-size-12 text-muted">
                              <p className="mb-1">{notification.details}</p>
                              <p className="mb-0">
                                <i className="mdi mdi-clock-outline"></i>{" "}
                                {new Date(notification.createdAt).toLocaleString()}
                              </p>
                            </div>
                          </Media>
                        </Media>
                      </Link>
                    );
                  })}
            </SimpleBar>
            {/* <div className="p-2 border-top">
              <Link
                to="#"
                className="btn btn-sm btn-link font-size-14 btn-block text-center"
              >
                <i className="mdi mdi-arrow-right-circle mr-1"></i>
                {this.props.t(" View More")}
              </Link>
            </div> */}
          </DropdownMenu>
        </Dropdown>
        <SocketComponent onNewNotification={this.handleNewNotification} />
      </React.Fragment>
    );
  }
}
export default withTranslation()(NotificationDropdown);
